export enum EtcTicketState {
  PENDING = 'PENDING', // 待處理、待查詢
  // 已查詢，有問題的狀態
  NO_FEE = 'NO_FEE', // 無需繳費
  QUERY_FAILED = 'QUERY_FAILED', // 查詢失敗
  // 已查詢，需繳費的狀態
  CHARGE_FAILED = 'CHARGE_FAILED', // 請款失敗
  CHARGING = 'CHARGING', // 扣款中
  CHARGE_SUCCESS = 'CHARGE_SUCCESS', // 請款成功
  COMPLETED = 'COMPLETED', // 繳費完成
}

export const ETC_STATE_VALUE = Object.values(EtcTicketState);

export const ETC_TICKET_STATE_POLICY = {
  [EtcTicketState.PENDING]: {
    text: '待處理',
  },
  [EtcTicketState.NO_FEE]: {
    text: '無需繳費',
  },
  [EtcTicketState.QUERY_FAILED]: {
    text: '查詢失敗',
  },
  // only come from server operation
  [EtcTicketState.CHARGING]: {
    text: '扣款中',
  },
  // only come from server operation
  [EtcTicketState.CHARGE_SUCCESS]: {
    text: '請款成功',
  },
  // only come from server operation
  [EtcTicketState.CHARGE_FAILED]: {
    text: '請款失敗',
  },
  [EtcTicketState.COMPLETED]: {
    text: '繳費完成',
  },
} as const satisfies Record<
  EtcTicketState,
  {
    text: string;
  }
>;
